module.exports = __webpack_public_path__ + "img/油耗.7bf32406.png";